import React, { useEffect, useRef, useState } from 'react';
import { vwSize } from '../../../../app/functions';
import StripNavItem from './components/nav-item';
import './index.scss';

const VerticalStrip = ({ sliders }) => {
    const verticalStripRef = useRef(null);
    const [offsetTop, setOffsetTop] = useState(0);
    const [indicatorOffset, setIndicatorOffset] = useState(10);
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        const header = document.querySelector('header');

        setOffsetTop(vwSize(header?.clientHeight, window.innerWidth) + vwSize(50, 1920));

        document.addEventListener('scroll', avoidFooter);
        return () => document.removeEventListener('scroll', avoidFooter);
    }, []);

    const avoidFooter = () => {
        const verticalStrip = document.querySelector('.vertical-strip-wrapper');

        if (verticalStrip) {
            const width = window.innerWidth;
            const header = document.querySelector('header');
            const stripOffsetTop = vwSize(header?.clientHeight, width) + vwSize(50, 1920);
            const stripHeight = vwSize(verticalStrip?.clientHeight, width);
            const scrollY = vwSize(window.scrollY, width);
            const footerOffsetTop = vwSize(document.querySelector('footer').offsetTop, width) - vwSize(50, 1920);
            const calculatedFromTop = scrollY + stripHeight + stripOffsetTop;

            if (calculatedFromTop >= footerOffsetTop) {
                const offsetFromFooter = stripOffsetTop + footerOffsetTop - calculatedFromTop;
                setOffsetTop(offsetFromFooter);
            } else {
                setOffsetTop(stripOffsetTop);
            }
        }
    }

    if (sliders) {
        let categoryArr = sliders.map(
            (slide) => ({
                uniqueId: slide.uniqueId,
                title: slide.slider.title,
                icon: slide.slider.icon_img || slide.slider.icon_path,
                type: Number(slide.type_id),
            })
        ).filter(
            // Only include sliders which are NOT banners (type 2)
            (slide) => slide.type !== 2
        );



        return (
            <div className='vertical-strip-wrapper' ref={verticalStripRef} style={{top: offsetTop + 'vw'}}>
                <div
                    className="indicator"
                    style={{ top: vwSize(indicatorOffset, 1920) + 'vw' }}
                />

                <div className="categories-wrapper">
                    {categoryArr.map((cat, idx) => (
                        <StripNavItem
                            key={`vertical-nav-item-${idx}`}
                            uniqueId={cat.uniqueId}
                            title={cat.title}
                            icon={cat.icon}
                            index={idx}
                            isSelected={idx === selectedIndex}
                            indicatorStateMethod={setIndicatorOffset}
                            setSelectedIndex={setSelectedIndex}
                        />
                    ))}
                </div>
            </div>
        );
    }

    return null;
};

export default VerticalStrip;
